import React from 'react'
import Router from './routes/Router'

type Props = {}

const App = (props: Props) => {
  return (
    <Router />
  )
}

export default App;